<template>
  <div class="PricingPlan">
    <h3 class="PricingPlan__title">{{ title }}</h3>
    <p v-if="price" class="PricingPlan__price">{{ price }}</p>
    <p v-if="priceSmall" class="PricingPlan__price-small">{{ priceSmall }}</p>
    <h4 v-if="subtitle" class="PricingPlan__subtitle">{{ subtitle }}</h4>
    <ul class="PricingPlan__features">
      <li
        class="PricingPlan__feature"
        v-for="feature in features"
        :key="feature"
      >
        <UIIcon class="PricingPlan__feature-icon" name="checkCircle" />
        {{ feature }}
      </li>
    </ul>
    <div class="PricingPlan__cta">
      <UIButton
        :theme="ctaTheme"
        :buttonStyle="ctaStyle"
        isFull
        :to="{
          name: 'Contact',
        }"
      >
        {{ ctaText }}
      </UIButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

export interface IPlan {
  title: string
  subtitle?: string
  price?: string
  priceSmall?: string
  features: string[]
  ctaText: string
  ctaTheme: 'primary' | 'secondary' | 'light'
  ctaStyle: 'filled' | 'outlined' | 'pale'
}

defineProps<IPlan>()
</script>

<style lang="scss" scoped>
.PricingPlan {
  box-shadow: 0px 3px 3px -1.5px #0010350a;
  box-shadow: 0px 8px 8px -4px #00103508;
  box-shadow: 0px 4px 24px -4px #00103514;
  border: 1px solid rgb(0 0 0 / 8%);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: fit-content;
  overflow: hidden;
  background-color: $color-white;
}

.PricingPlan__title {
  @include font-size-20px();
  font-weight: 600;
  text-align: center;
  color: $color-ui-brand-700;
  margin-bottom: 0.5rem;
  padding-top: 2rem;
}

.PricingPlan__subtitle {
  @include font-size-24px();
  text-align: center;
  color: $color-ui-gray-cool-600;
}

.PricingPlan__price {
  @include font-size-36px();
  font-weight: 600;
  text-align: center;
  color: $color-ui-gray-cool-900;
}

.PricingPlan__price-small {
  @include font-size-24px();
  font-weight: 600;
  text-align: center;
  color: $color-ui-gray-cool-900;
}

.PricingPlan__features {
  padding: 2rem 2rem 2.5rem;
  list-style: none;
  gap: 1rem;
  display: flex;
  flex-direction: column;
}

.PricingPlan__feature {
  display: flex;
  gap: 0.75rem;
}

.PricingPlan__feature-icon {
  --size: 1.5rem;
}

.PricingPlan__cta {
  background-color: $color-ui-gray-cool-50;
  border-top: 1px solid $color-ui-gray-cool-200;
  padding: 2rem;
}
</style>
